import {useDispatch, useSelector} from "react-redux";
import {
    assetsDialogsSelector,
    cleanVirtualAssets,
    replaceMinMaxLoadedPage,
    setImportCsvDialogAction
} from "../../../store/store";
import {
    getCsvFieldsVirtualAction,
    getVirtualAssetsAction,
    importCsvTemplateVirtualAssetsAction,
    performCsvVirtualAction
} from "../../../store/actions";
import {TImportCsvDialogProps} from "../../../../../../newShared/components/csvImportDialog";
import {resetImportCsvDialog} from "../../../../../../newShared/components/csvImportDialog/constants";
import {DEFAULT_PAGING} from "../../../../../../newShared/components/genericTable/constants";
import {
    useGenericFiltersStorage
} from "../../../../../../newShared/components/genericFilter/hooks/useGenericFiltersStorage";

export const useImportCsvVirtual = (): TImportCsvDialogProps => {
    const dispatch = useDispatch();
    const {importCsvDialog: {
        isOpen,
        isLoading: {
            isGettingFields,
            isPerformingCsv,
            isLoadingTemplate,
        },
        fields,
        fileId,
        response,
    }} = useSelector(assetsDialogsSelector);

    const setImportDialog: TImportCsvDialogProps["setImportDialog"] = (data) => dispatch(setImportCsvDialogAction(data));
    const downloadTemplate = () => {dispatch(importCsvTemplateVirtualAssetsAction())};

    const getFields: TImportCsvDialogProps["getFields"] = (file) => {dispatch(getCsvFieldsVirtualAction({
        data: {...file},
        onError: resetImportCsvDialog,
    }))};

    const {clearFilters} = useGenericFiltersStorage();

    const performCsv: TImportCsvDialogProps["performCsv"] = (fields) => {fileId && dispatch(performCsvVirtualAction({
        data: {fields, fileId},
        // snack: "success",
        // onError: (request, error, addictiveData) => {dispatch(setImportCsvDialogAction({error: error[0]?.message || 'Unknown error'}))},
        onSuccess: (_, response) => {
            clearFilters();
            dispatch(cleanVirtualAssets())
            dispatch(replaceMinMaxLoadedPage({minLoadedPage: -1, maxLoadedPage: -1}));
            dispatch(getVirtualAssetsAction({data: {page: 0, count: DEFAULT_PAGING, filters: {}}}));
        },
    }))};

    return {
        isOpen,
        isLoadingTemplate, isPerformingCsv, isGettingFields,
        fields,
        setImportDialog,
        downloadTemplate,
        getFields,
        performCsv,
        response,
        fieldsMapperKey: "assets",
    }
}
